import domReady from '@wordpress/dom-ready';

domReady(async () => {
	const selector = '.js-block-post-meta';
	const elements = document.querySelectorAll(selector);

	if (!elements.length) {
		return;
	}

	const { PostMeta } = await import('./post-meta');

	[...elements].forEach((element) => {
		const postMeta = new PostMeta({
			element,
		});

		postMeta.init();
	});
});
